import { useDispatch } from 'react-redux';
import { AddAlert, Button, Modal } from '../../../../component';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import { loaded, loading } from '../../../../layout/redux/layoutActions';
import { modalOpen } from '../../redux/dashboardActions';
import nls from '../nls/pt-BR.json';
import { deleteStudy } from '../redux/studies.controller';
import { setSelectedStudy, studiesSelector } from '../redux/studies.reducer';
import { useStudiesList } from '../useStudiesList';

export const ConfirmDeleteModal: React.FC = () => {
  const { statusModal } = useTypedSelector((state) => state.dashboardState);
  const { selectedStudy, pagination, titleSearchInput } =
    useTypedSelector(studiesSelector);
  const { getList } = useStudiesList();
  const dispatch = useDispatch();
  const handleDelete = async () => {
    try {
      dispatch(loading());
      if (selectedStudy) {
        dispatch(modalOpen(''));
        await deleteStudy(selectedStudy.id);
        await getList(pagination.currentPage.toString(), titleSearchInput);
        dispatch([
          setSelectedStudy(null),
          AddAlert('success', 'Relatório removido com sucesso'),
        ]);
      }
    } catch (error) {
      dispatch(AddAlert('warning', 'Erro ao deletar relatório'));
    } finally {
      dispatch(loaded());
    }
  };
  return (
    <Modal
      open={statusModal === 'confirm delete study modal'}
      close={() => dispatch(modalOpen(''))}
      cy="ConfirmDeleteStudy"
      title={nls.modal.confirmDelete.title}
      hasCancelBtn={false}
      actions={
        <>
          <Button
            className="btn primary normal"
            style={{ backgroundColor: 'red', color: '#FFF' }}
            cy="ConfirmDeleteStudy"
            onClick={handleDelete}
          >
            {nls.modal.confirmDelete.delete}
          </Button>
        </>
      }
    >
      {nls.modal.confirmDelete.helper}
    </Modal>
  );
};
